module.exports = __webpack_public_path__ + "media/unipod/pod_construciton_1-3b546129.jpg";